import React, { useState } from "react";
import { useListingPreviewResizer } from "../listing/LiveListingPreview";
import MyRecentSalesListings from "./MyRecentSalesListings";
import { Container } from "./styled/live-guidance-my-recent-sales-listings";
import LiveGuidanceMyRecentSalesDetailsModal from "./LiveGuidanceMyRecentSalesDetailsModal";

function LiveGuidanceMyRecentSalesListings() {
  const { headerDetails } = useListingPreviewResizer();
  const [previewListingId, setPreviewListingId] = useState(null);

  return (
    <Container>
      <MyRecentSalesListings
        previewListingId={previewListingId}
        setPreviewListingId={setPreviewListingId}
      />
      {previewListingId && (
        <LiveGuidanceMyRecentSalesDetailsModal
          style={{ top: headerDetails.bottom }}
          listingRecordId={previewListingId}
          showInModal={true}
          onClose={() => setPreviewListingId(null)}
        />
      )}
    </Container>
  );
}

export default LiveGuidanceMyRecentSalesListings;
